import SolidBoltAltIcon from 'LuxKit/Icons/solid/SolidBoltAltIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import Caption from 'LuxKit/Typography/Caption'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import { FormattedMessage } from 'react-intl'
import type { BookingLabelThreshold } from './urgencyLabelVisibility'
import { shouldShowBookingsCountLabel } from './urgencyLabelVisibility'

interface Props {
  /**
   * The number of bookings that have been made
   */
  bookings: number
  /**
   * The threshhold to apply to the booking counts
   * Internally this label knows what they are, you just
   * pass what type of threshold you want
   */
  threshold: BookingLabelThreshold
}

function BookingsCountLabel(props: Props) {
  const { bookings, threshold } = props

  if (!shouldShowBookingsCountLabel(bookings, threshold)) {
    return null
  }

  return <PromotionLabel
    icon={<SolidBoltAltIcon />}
  >
    <Caption variant="medium" weight="bold">
      <FormattedMessage
        id="_aDMVbs9cFFympB8wgu-"
        defaultMessage="Booked {bookingCount} times in 3 days"
        description="Promotion label showing recent booking count for social proof"
        values={{ bookingCount: <FormatDecimal value={bookings} /> }}
      />
    </Caption>
  </PromotionLabel>
}

export default BookingsCountLabel
